/* eslint-disable no-unused-vars */
import storage from 'good-storage'
import * as util from '@/assets/js/util'

const MYPOSITION_KEY = '__myPosition__'
const MYSESRCH_KEY = '__mySearch__'
const USER_KEY = '__user__'
const DESIGNATION_KEY = '__designation__'
const MSGLIST_KEY = '__msgList'
const NOTIFY_COUNT = '__notifyCount__'
const UNREADMSG = '__unReadMsg__'
const TOKEN = '__token__'
const LIKEMSG = '__likeMsg__'
const COMMENTMSG = '__commentMsg__'
const FOLLOWMSG = '__followMsg__'
const WALLETMSG = '__walletMsg__'
const POST_AGREE = '__postAgredd__'
const ARTICLE_READ_LIST = '__articleReadList__'

function insertArray (arr, val, compare, maxLen) {
  const index = arr.findIndex(compare)
  if (index === 0) {
    return
  }
  if (index > 0) {
    arr.splice(index, 1)
  }
  arr.unshift(val)
  if (maxLen && arr.length > maxLen) {
    arr.pop()
  }
}

function deleteFromArray (arr, compare) {
  const index = arr.findIndex(compare)
  if (index > -1) {
    arr.splice(index, 1)
  }
}

export function saveMyPostion (postion) {
  storage.set(MYPOSITION_KEY, postion)
}

export function removeMypostion () {
  storage.remove(MYPOSITION_KEY)
}

export function loadMyPosition () {
  return storage.get(MYPOSITION_KEY, {})
}

export function saveMySearch (search) {
  storage.set(MYSESRCH_KEY, search)
}

export function loadMySearch () {
  return storage.get(MYSESRCH_KEY, [])
}

export function saveUser (user) {
  storage.set(USER_KEY, user)
}

export function loadUser () {
  return storage.get(USER_KEY, {})
}

export function saveDesignation (designation) {
  storage.set(DESIGNATION_KEY, designation)
}

export function loadDesignation () {
  return storage.get(DESIGNATION_KEY, [])
}

export function loadMsgList () {
  return storage.get(MSGLIST_KEY, {})
}

export function saveMsgList (msgContent) {
  storage.set(MSGLIST_KEY, msgContent)
}

export function addMsg (msg) {
  const msgList = storage.get(MSGLIST_KEY, {})
  if (util.isEmptyObject(msgList[msg.uid])) {
    msgList[msg.uid] = []
  }
  msgList[msg.uid].push(msg)
  storage.set(MSGLIST_KEY, msgList)
}

export function loadMsg (uid, current, pageNum) {
  const count = current * (pageNum - 1)
  const msgList = storage.get(MSGLIST_KEY, {})[uid]
  if (!util.isEmptyObject(msgList)) {
    const newMsgList = []
    const minPos = msgList.length - current * pageNum > 0 ? msgList.length - current * pageNum : 0
    const maxPos = msgList.length - (current - 1) * pageNum
    for (let i = maxPos - 1; i >= minPos; --i) {
      newMsgList.unshift(msgList[i])
    }
    return newMsgList
  }
  return []
}

export function deleteMsg (uid) {
  const msgList = storage.get(MSGLIST_KEY, {})
  delete msgList[uid]
  storage.set(MSGLIST_KEY, msgList)
}

export function setNotify (notify) {
  storage.set(NOTIFY_COUNT, notify)
}

export function loadNotify () {
  return storage.get(NOTIFY_COUNT, {})
}

export function loadNotifyCount (id) {
  const a = storage.get(NOTIFY_COUNT, {})
  return a[id] ? a[id] : 0
}

export function setUnReadMsg (msgList) {
  storage.set(UNREADMSG, msgList)
}

export function loadUnReadMsg () {
  return storage.get(UNREADMSG, {})
}

export function setToken (token) {
  storage.set(TOKEN, token)
}

export function getToken () {
  return storage.get(TOKEN, '')
}

/**
 * 点赞消息
 * @param likeMsg
 */
export function setLikeMsg (likeMsg) {
  storage.set(LIKEMSG, likeMsg)
}

export function getLikeMsg () {
  return storage.get(LIKEMSG, {})
}

export function setCommentMsg (commentMsg) {
  storage.set(COMMENTMSG, commentMsg)
}

export function getCommentMsg () {
  return storage.get(COMMENTMSG, {})
}

export function setWalletMsg (walletMsg) {
  storage.set(WALLETMSG, walletMsg)
}

export function getWalletMsg () {
  return storage.get(WALLETMSG, {})
}

export function setFollowMsg (followMsg) {
  storage.set(FOLLOWMSG, followMsg)
}

export function getFollowMsg () {
  return storage.get(FOLLOWMSG, {})
}

export function setPostAgree (val) {
  storage.set(POST_AGREE, val)
}

export function getPostAgree () {
  return storage.get(POST_AGREE, false)
}

export function addArticle (id) {
  let articleList = storage.get(ARTICLE_READ_LIST, [])
  if (!util.inArray(id, articleList)) {
    articleList.push(id)
    storage.set(ARTICLE_READ_LIST, articleList)
  }
}

export function findArticle (id) {
  let articleList = storage.get(ARTICLE_READ_LIST, [])
  return util.inArray(id, articleList)
}



// WEBPACK FOOTER //
// ./src/assets/js/cache.js